/*
  Blog post templates (how-to, comparison, guide): the Jump To bar, its scroll
  spy and reading-progress line, and the how-to's spine.

  The bar hangs under the theme's sticky header. Its offset is measured from
  the header itself on every frame, so it follows the header's real height
  (60px on mobile, 86px on desktop) without hard-coding either.
*/
(function () {
  var root = document.querySelector('.bp');
  if (!root) return;

  var bar = root.querySelector('[data-bp-jbar]');
  var hero = root.querySelector('.hero');
  var art = root.querySelector('.art');
  var header = document.getElementById('shopify-section-header') || document.querySelector('header');
  var links = bar ? [].slice.call(bar.querySelectorAll('a')) : [];
  var secs = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
  var ol = bar ? bar.querySelector('ol') : null;
  var line = bar ? bar.querySelector('.jb-line') : null;
  var spine = root.querySelector('.spine');
  var fill = spine ? spine.querySelector('.spine-fill') : null;
  var steps = spine ? [].slice.call(spine.querySelectorAll('.sstep')) : [];
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur = -1, ticking = false;

  function headerBottom() {
    if (!header) return 0;
    return Math.max(0, header.getBoundingClientRect().bottom);
  }

  function spy() {
    ticking = false;
    var hb = headerBottom();
    root.style.setProperty('--bp-hdr', hb + 'px');

    if (bar) {
      // The bar appears once the hero has scrolled up under the header.
      bar.classList.toggle('is-on', hero ? hero.getBoundingClientRect().bottom <= hb : true);

      var idx = 0;
      for (var i = 0; i < secs.length; i++) {
        if (secs[i] && secs[i].getBoundingClientRect().top <= 190) idx = i;
      }
      if (idx !== cur) {
        cur = idx;
        links.forEach(function (a, i) { a.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        // On small screens the bar is a scrolling chip strip: centre the active chip.
        if (ol && ol.scrollWidth > ol.clientWidth) {
          var a = links[idx];
          ol.scrollTo({ left: a.offsetLeft - (ol.clientWidth - a.offsetWidth) / 2, behavior: still ? 'auto' : 'smooth' });
        }
      }

      if (line && art) {
        var r = art.getBoundingClientRect(), span = r.height - window.innerHeight * 0.6;
        line.style.width = Math.max(0, Math.min(1, (190 - r.top) / span)) * 100 + '%';
      }
    }

    if (spine && fill) {
      var sr = spine.getBoundingClientRect(), mark = window.innerHeight * 0.45;
      fill.style.height = Math.max(0, Math.min(sr.height - 16, mark - sr.top - 8)) + 'px';
      steps.forEach(function (s) {
        var n = s.querySelector('.snum').getBoundingClientRect();
        var mid = n.top + n.height / 2;
        var next = s.nextElementSibling ? s.nextElementSibling.getBoundingClientRect().top : Infinity;
        s.classList.toggle('now', mid <= mark && next > mark);
        s.classList.toggle('passed', mid <= mark && next <= mark);
      });
    }
  }

  // Sticky rail: measure the header and Jump To bar it sits under, so its
  // height cap is the space actually left on screen, and flag when its
  // products overflow that cap (CSS then shows the scrollbar and fade).
  var rail = root.querySelector('.rail');
  function railFit() {
    if (!rail) return;
    root.style.setProperty('--bp-hdr-h', (header ? header.offsetHeight : 0) + 'px');
    root.style.setProperty('--bp-jb-h', (bar ? bar.offsetHeight : 0) + 'px');
    var over = rail.scrollHeight > rail.clientHeight + 1;
    rail.classList.toggle('is-scrollable', over);
    rail.classList.toggle('at-end', !over || rail.scrollTop + rail.clientHeight >= rail.scrollHeight - 2);
  }
  if (rail) {
    rail.addEventListener('scroll', railFit, { passive: true });
    [].forEach.call(rail.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', railFit);
    });
    if (window.ResizeObserver) new ResizeObserver(railFit).observe(rail.firstElementChild || rail);
  }

  // FAQ: one answer open at a time. Details that share a name do this
  // natively; this covers browsers that predate exclusive accordions.
  var faq = root.querySelector('.pfaq');
  if (faq) {
    faq.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d.tagName !== 'DETAILS' || !d.open) return;
      [].forEach.call(faq.querySelectorAll('details[open]'), function (o) {
        if (o !== d) o.open = false;
      });
    }, true);
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(spy); }
  }, { passive: true });
  window.addEventListener('resize', function () { spy(); railFit(); });
  spy();
  railFit();
})();
